import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import { grey } from '@mui/material/colors'
import { useTheme } from '@emotion/react';
import { useRecoilValue } from 'recoil';
import StepperCustom from 'src/shared/components/steps/StepperCustom';
import { activeStepResetPasswordState, completedStepResetPasswordState } from '../recoveryPassword/state/atoms';


const steps = ['Solicitud clave', 'Clave temporal', 'Nueva contraseña'];
const StepsResetPassword = ({ color = "white" }) => {

  const theme = useTheme();
  const activeStepResetPassword = useRecoilValue(activeStepResetPasswordState);
  const completedStepResetPassword = useRecoilValue(completedStepResetPasswordState);  

  return (
    <Box sx={{ padding: 1, maxWidth: 720, margin: '0 auto' }}>
      <StepperCustom color={color} theme={theme} nonLinear activeStep={activeStepResetPassword}>
        {steps.map((label, index) => (
          <Step key={label} completed={completedStepResetPassword[index]}>
            <StepButton disableRipple color={grey[400]}>
              {label}
            </StepButton>
          </Step>
        ))}
      </StepperCustom>
    </Box>
  );
}

export default StepsResetPassword;